if (!window.rtx) {
  window.rtx = {};
}

window.rtx.product = function (options) {
  var selectors = {
    newPrice: ".rtx-new-price",
    newPriceSubscriptionDiscount: ".rtx-new-price-subscription-discount",
    sellingPlanGroup: ".rtx-selling-plan-group",
    sellingPlanGroupContents: ".rtx-selling-plan-group-contents",
    noPlansAvailable: ".rtx-no-plans-available",
  };

  var formSelector = options.formSelector;
  var sellingPlanGroupsSelector = options.sellingPlanGroupsSelector;
  var sellingPlanIdInputSelector = options.sellingPlanIdInputSelector;
  var priceContainerSelector = options.priceContainerSelector;
  var regularPriceSelector = options.regularPriceSelector;
  var salePriceSelector = options.salePriceSelector;
  var variantSelectorSelector = options.variantSelectorSelector;

  var product = options.product;
  var groupToSellingPlans = options.groupToSellingPlans;
  var variantToPrice = options.variantToPrice;
  var variantToSellingPlanAllocations = options.variantToSellingPlanAllocations;
  var priceDisplayMode = options.priceDisplayMode || "strike";
  var showSubscriptionDiscountBadge = !!options.showSubscriptionDiscountBadge;

  var $form;
  var $sellingPlanIdInput;

  var variantsHandler;
  var priceDisplayHandler;
  var sellingPlanGroupsHandler;
  var quantityHandler;

  document.body.classList.add(
    "rtx-theme-" + encodeURIComponent(options.theme.toLowerCase().replace(/s/g, "-"))
  );
  document.addEventListener("DOMContentLoaded", initialize);

  function initialize() {
    $form = document.querySelector(formSelector);
    $sellingPlanIdInput = document.querySelectorAll(sellingPlanIdInputSelector);

    if ($form === null || !$sellingPlanIdInput.length) {
      throw new Error(createErrorMessage("One or more elements required were not found."));
    }

    variantsHandler = new VariantsHandler({
      selector: variantSelectorSelector,
      product: product,
    });

    sellingPlanGroupsHandler = new SellingPlanGroupsHandler({
      variantsHandler: variantsHandler,
      sellingPlanGroupsSelector: sellingPlanGroupsSelector,
    });

    if (options.quantitySelector && document.querySelector(options.quantitySelector)) {
      quantityHandler = new QuantityHandler({ selector: options.quantitySelector });
      quantityHandler.on("updateQuantity", function () {
        priceDisplayHandler.update();
      });
    }

    priceDisplayHandler = new PriceDisplayHandler({
      variantsHandler: variantsHandler,
      sellingPlanGroupsHandler: sellingPlanGroupsHandler,
      quantityHandler: quantityHandler,
      product: product,
      selector: priceContainerSelector,
      regularPriceSelector: regularPriceSelector,
      salePriceSelector: salePriceSelector,
      displayMode: priceDisplayMode,
      showBadge: showSubscriptionDiscountBadge,
    });

    variantsHandler.on("updateVariant", function () {
      sellingPlanGroupsHandler.update();
      priceDisplayHandler.update();
    });

    sellingPlanGroupsHandler.on("updatePlanId", function (e) {
      var planId = e.detail.planId;
      $sellingPlanIdInput.forEach(function ($input) {
        $input.setAttribute("value", planId || "");
      });
      priceDisplayHandler.update();
    });
  }

  /* data getters */
  function getCurrentSellingPlanId() {
    return $sellingPlanIdInput[0].getAttribute("value");
  }

  function getCurrentSellingPlan() {
    var currentPlanId = getCurrentSellingPlanId();
    var groupId = sellingPlanGroupsHandler.getCurrentGroupId();

    if (!groupId) {
      return "";
    }

    return groupToSellingPlans[groupId].find(function (plan) {
      return Number(plan.id) === Number(currentPlanId);
    });
  }

  function getPlanAllocationFormattedPriceFromVariantAndPlanId(variantId, planId, quantity) {
    var sellingPlanAllocation = variantToSellingPlanAllocations[variantId].find(function (alloc) {
      return Number(alloc.sellingPlanId) === Number(planId);
    });

    return sellingPlanAllocation ? formatMoney(sellingPlanAllocation.priceWithDecimals * quantity) : "";
  }

  function SellingPlanGroupsHandler(options) {
    this.variantsHandler = options.variantsHandler;
    this.sellingPlanGroupsSelector = options.sellingPlanGroupsSelector;

    this.$sellingPlanGroupsContainer = document.querySelector(options.sellingPlanGroupsSelector);
    this.$radioInputs = Array.from(this.$sellingPlanGroupsContainer.querySelectorAll('input[type="radio"]'));

    this.dispatcher = new EventTarget();

    if (this.$radioInputs.length) {
      this.$radioInputs[0].click();
    }

    var that = this;
    this.$radioInputs.forEach(function ($input) {
      $input.addEventListener("change", function (e) {
        var groupId = e.currentTarget.value || "";

        that._showGroupContents(groupId);
        if (groupId) {
          that.update();
          var planId = that._getSelectedPlanIdFromGroupId(groupId);
          that._dispatchPlanId(planId ? "" + planId : "");
        } else {
          that._dispatchPlanId("");
        }
      });
    });

    this._getAllSelingPlanGroupPlanSelectors().forEach(function ($selector) {
      $selector.addEventListener(
        "change",
        function (e) {
          this._dispatchPlanId(e.currentTarget.value);
        }.bind(this)
      );
    }, this);

    this.update();
  }

  SellingPlanGroupsHandler.prototype = Object.assign({}, SellingPlanGroupsHandler.prototype, {
    on: function (event, cb) {
      this.dispatcher.addEventListener(event, cb);
    },

    update: function () {
      var variant = this.variantsHandler.getCurrentVariant();
      var variantId = variant ? variant.id : "";
      var variantHasAnyPlans = variant && variantToSellingPlanAllocations[variant.id].length;

      if (!variant || (variant.requires_selling_plan && !variantHasAnyPlans)) {
        show(this._getNoPlansMessage());
        hide(this.$sellingPlanGroupsContainer);
        this._dispatchPlanId("");
        return;
      } else {
        hide(this._getNoPlansMessage());
        show(this.$sellingPlanGroupsContainer);
      }

      this.$radioInputs.forEach(function ($radio) {
        var groupId = $radio.value;
        if (this._isOTP(groupId)) return;

        var variantSellingPlans = this._getSellingPlansForVariantAndGroup(variantId, groupId);

        var $options = this._getGroupPlanSelectorOptions(groupId);
        $options.forEach(function ($option) {
          var variantHasSellingPlan = variantSellingPlans.find(function (plan) {
            return Number(plan.id) === Number($option.value);
          });
          setElementDisabled($option, !variantHasSellingPlan);
        });

        if (
          $radio.checked &&
          variantSellingPlans.length &&
          !variantSellingPlans.find(function (plan) {
            return Number(plan.id) === Number(getCurrentSellingPlanId());
          })
        ) {
          this._selectFirstEnabledPlanForGroup(groupId);
        }

        if ($radio.checked && !variantSellingPlans.length && !variant.requires_selling_plan) {
          this._getOTPRadioInput().click();
        }

        setElementDisabled($radio, !variantSellingPlans.length);
      }, this);
    },

    getCurrentGroupId: function () {
      var $checkedRadio = this.$radioInputs.find(function ($radio) {
        return $radio.checked === true;
      });
      return $checkedRadio ? $checkedRadio.value : "";
    },

    getCurrentPlanId: function () {
      return this._getSelectedPlanIdFromGroupId(this.getCurrentGroupId());
    },

    _dispatchPlanId: function (planId) {
      return this.dispatcher.dispatchEvent(
        new CustomEvent("updatePlanId", {
          detail: { planId: planId },
        })
      );
    },

    _getSellingPlansForVariantAndGroup: function (variantId, groupId) {
      if (!groupId) return [];
      return groupToSellingPlans[groupId].filter(function (plan) {
        return variantToSellingPlanAllocations[variantId].find(function (alloc) {
          return plan.id === alloc.sellingPlanId;
        });
      });
    },

    _getOTPRadioInput: function () {
      return this.$radioInputs.find(function ($radio) {
        return !$radio.value;
      });
    },

    _getGroups: function () {
      return Array.from(document.querySelectorAll(selectors.sellingPlanGroup));
    },

    _getAllSelingPlanGroupPlanSelectors: function () {
      return Array.from(this.$sellingPlanGroupsContainer.querySelectorAll("select"));
    },

    _getGroupPlanSelector: function (group) {
      var $group = typeof group === "string" ? this._getGroupElementFromGroupId(group) : group;
      return $group.querySelector("select");
    },

    _getGroupPlanSelectorValue: function ($group) {
      var $selector = this._getGroupPlanSelector($group);
      var groupId = this._getGroupIdFromGroupElement($group);
      return $selector ? Number($selector.value) : groupToSellingPlans[groupId][0].id;
    },

    _getSelectedPlanIdFromGroupId: function (groupId) {
      var $group = this._getGroupElementFromGroupId(groupId);
      return this._getSelectedPlanIdFromGroup($group);
    },

    _getSelectedPlanIdFromGroup: function ($group) {
      var $planSelector = this._getGroupPlanSelector($group);
      var groupId = this._getGroupIdFromGroupElement($group);

      if (groupToSellingPlans[groupId].length <= 1) {
        return groupToSellingPlans[groupId][0].id || null;
      }

      return $planSelector ? $planSelector.value : null;
    },

    _getGroupPlanSelectorOptions: function (group) {
      var $selector = this._getGroupPlanSelector(group);
      return $selector ? Array.from($selector.querySelectorAll("option")) : [];
    },

    _getGroupContents: function ($group) {
      return $group.querySelector(selectors.sellingPlanGroupContents);
    },

    _getGroupIdFromGroupElement: function ($group) {
      return $group.getAttribute("data-group-id");
    },

    _getGroupElementFromGroupId: function (groupId) {
      return $form.querySelector("[data-group-id='" + groupId + "']");
    },

    _selectFirstEnabledPlanForGroup: function (group) {
      var $selector = this._getGroupPlanSelector(group);
      var $options = this._getGroupPlanSelectorOptions(group);
      var $firstEnabledOption = $options.find(function ($option) {
        return !$option.getAttribute("disabled");
      });
      $selector.value = $firstEnabledOption.value;
      this._dispatchPlanId($firstEnabledOption.value);
    },

    _isOTP: function (groupId) {
      return !groupId;
    },

    _showGroupContents: function (groupId) {
      var $groups = this._getGroups();
      var $groupToShow = $groups.find(
        function ($group) {
          return this._getGroupIdFromGroupElement($group) === groupId;
        }.bind(this)
      );

      $groups.forEach(
        function ($group) {
          var $contents = this._getGroupContents($group);
          if (!$contents) return;
          $group === $groupToShow ? show($contents) : hide($contents);
        }.bind(this)
      );

      if (!groupId) {
        this._dispatchPlanId(""); // OTP
      } else if ($groupToShow) {
        this._dispatchPlanId(this._getGroupPlanSelectorValue($groupToShow));
      }
    },

    _getNoPlansMessage: function () {
      return $form.querySelector(selectors.noPlansAvailable);
    },
  });

  function PriceDisplayHandler(options) {
    this.variantsHandler = options.variantsHandler;
    this.sellingPlanGroupsHandler = options.sellingPlanGroupsHandler;
    this.quantityHandler = options.quantityHandler;
    this.product = options.product;
    this.displayMode = options.displayMode;
    this.showBadge = options.showSubscriptionDiscountBadge;
    this.selector = options.selector;

    this.$container = document.querySelector(options.selector);
    if (!this.$container) {
      console.warn(
        "No price display element was found."
      );
      return;
    }

    this.$regularPrice = this.$container.querySelector(options.regularPriceSelector || "[data-regular-price]");
    if (this.$regularPrice) {
      this.$regularPrice.setAttribute("data-price-type", "regular");
    }
    this.$salePrice = this.$container.querySelector(options.salePriceSelector || "[data-sale-price]");
    if (this.$salePrice) {
      this.$salePrice.setAttribute("data-price-type", "sale");
    }

    this.$newRegularPriceContainer = this._createNewPriceContainer(
      this.$regularPrice,
      "regular",
      this.displayMode
    );
    this.$newSalePriceContainer = this._createNewPriceContainer(this.$salePrice, "sale", this.displayMode);

    this.update();
  }

  PriceDisplayHandler.prototype = Object.assign({}, PriceDisplayHandler.prototype, {
    update: function () {
      if (!this.$container) {
        return;
      }

      var planId = getCurrentSellingPlanId();
      var variantId = this.variantsHandler.getCurrentVariant().id;
      var quantity = this.quantityHandler ? this.quantityHandler.getQuantity() : 1;

      if (typeof variantId !== "number") {
        this._overwritePrice("");
        return;
      }

      var newInnerText = planId
        ? getPlanAllocationFormattedPriceFromVariantAndPlanId(variantId, planId, quantity)
        : formatMoney(variantToPrice[variantId].priceWithDecimals * quantity);

      if (!newInnerText) {
        var variantPrice = formatMoney(variantToPrice[variantId].priceWithDecimals * quantity);
        this.displayMode === "strike" ? this._unstrike(variantPrice) : this._overwrite(variantPrice);
        return;
      }

      if (priceDisplayMode === "strike") {
        planId ? this._strike(newInnerText) : this._unstrike(newInnerText);
      } else {
        this._overwrite(newInnerText);
      }
    },

    _createNewPriceContainer: function ($priceEl, priceType, displayMode) {
      if (priceType !== "regular" && priceType !== "sale") {
        throw new Error(createErrorMessage("Invalid price type."));
      }

      if (!$priceEl) {
        return null;
      }

      var $newPriceContainer = createElement(
        "div",
        ["rtx-new-price-container"],
        {},
        { "data-price-type": priceType }
      );

      var $discount = createElement("div", ["rtx-new-price-subscription-discount"], {
        borderColor: document.body.color,
      });

      $priceEl.insertAdjacentElement("afterend", $newPriceContainer);
      updateText($priceEl, $priceEl.innerText.trim());

      if (displayMode === "strike") {
        var $newPrice = document.createElement("div");
        $newPrice.classList.add("rtx-new-price");
        $newPriceContainer.appendChild($newPrice);
      }

      if (this.showBadge) {
        $newPriceContainer.appendChild($discount);
      }

      return $newPriceContainer;
    },

    _getActivePrice: function () {
      if (!isHidden(this.$regularPrice)) {
        return this.$regularPrice;
      } else if (!isHidden(this.$salePrice)) {
        return this.$salePrice;
      } else {
        throw new Error(createErrorMessage("Couldn't get visible price display."));
      }
    },

    _getActiveNewPriceContainer: function () {
      if (!isHidden(this.$newRegularPriceContainer)) {
        return this.$newRegularPriceContainer;
      } else if (!isHidden(this.$newSalePriceContainer)) {
        return this.$newSalePriceContainer;
      } else {
        throw new Error(createErrorMessage("Couldn't get visible new price display."));
      }
    },

    _overwrite: function (amountText) {
      var $price = this._getActivePrice();
      var priceType = $price.getAttribute("data-price-type");
      updateText($price, amountText);

      var $activeContainer =
        priceType === "regular" ? this.$newRegularPriceContainer : this.$newSalePriceContainer;
      var $inactiveContainer =
        priceType === "regular" ? this.$newSalePriceContainer : this.$newRegularPriceContainer;
      if (!this.sellingPlanGroupsHandler.getCurrentGroupId()) {
        hide($activeContainer);
        hide($inactiveContainer);
      } else {
        this._updateNewPriceDiscount($activeContainer, getCurrentSellingPlan());
        show($activeContainer);
        hide($inactiveContainer);
      }
    },

    _strike: function (amountText) {
      var $price = this._getActivePrice();
      var priceType = $price.getAttribute("data-price-type");
      var $activeContainer =
        priceType === "regular" ? this.$newRegularPriceContainer : this.$newSalePriceContainer;
      var $inactiveContainer =
        priceType === "regular" ? this.$newSalePriceContainer : this.$newRegularPriceContainer;
      if (!$activeContainer) {
        throw new Error(createErrorMessage("Failed to retrieve new price container."));
      }

      strikeText(priceType === "regular" ? this.$regularPrice : this.$salePrice, true);

      this._setNewPrice($activeContainer, amountText);
      this._updateNewPriceDiscount($activeContainer, getCurrentSellingPlan());

      show($activeContainer);
      hide($inactiveContainer);

      if (this.$container.querySelector(".price__sale")) {
        // debut
        this.$container
          .querySelector(".price__sale")
          .querySelectorAll("[data-regular-price]")
          .forEach(function ($el) {
            priceType === "sale" ? hide($el) : show($el);
          });
      }
    },

    _unstrike: function () {
      var $price = this._getActivePrice();
      var priceType = $price.getAttribute("data-price-type");
      strikeText($price, false);
      try {
        var $container = this._getActiveNewPriceContainer();
        hide($container);
      } catch (e) {
        //
      }

      if (this.$container.querySelector(".price__sale")) {
        // debut
        this.$container
          .querySelector(".price__sale")
          .querySelectorAll("[data-regular-price]")
          .forEach(function ($el) {
            priceType === "sale" ? show($el) : hide($el);
          });
      }
    },

    _setNewPrice: function ($container, amountText) {
      var $newPrice = $container.querySelector(selectors.newPrice);
      if ($newPrice) updateText($newPrice, amountText);
    },

    _updateNewPriceDiscount: function ($container, sellingPlan) {
      if (!sellingPlan) {
        return;
      }

      var $discount = $container.querySelector(selectors.newPriceSubscriptionDiscount);
      if (!$discount) {
        return;
      }

      var discountValue = sellingPlan.price_adjustments[0].value;
      if ($discount && discountValue) updateText($discount, "Subscription - save " + discountValue + "%");
    },
  });

  function VariantsHandler(options) {
    this.product = options.product;
    this.selector = options.selector;

    this.dispatcher = new EventTarget();

    this.$options = Array.from(document.querySelectorAll(options.selector));

    var that = this;
    this.$options.forEach(function ($option) {
      var type = $option.getAttribute("type");
      $option.addEventListener(type === "button" ? "click" : "change", function () {
        setTimeout(function () {
          that._dispatchVariant(that.getCurrentVariant());
        }, 10);
      });
    });
  }

  VariantsHandler.prototype = Object.assign({}, VariantsHandler.prototype, {
    on: function (event, cb) {
      this.dispatcher.addEventListener(event, cb);
    },

    getCurrentVariant: function () {
      var selectedOptions = this._getSelectedOptions();

      var variant = this.product.variants.find(function (variant) {
        return selectedOptions.every(function (values) {
          return variant[values.index] === values.value;
        });
      });

      return variant;
    },

    _dispatchVariant: function (variant) {
      this.dispatcher.dispatchEvent(
        new CustomEvent("updateVariant", {
          detail: variant,
        })
      );
    },

    _getSelectedOptions: function () {
      return this.$options.reduce(function (acc, $option, arrayIndex) {
        var type = $option.getAttribute("type");
        var isSelectedButton = type === "button" && $option.classList.contains("active");
        var isRadioCheckboxOrButton = type === "radio" || type === "checkbox" || type === "button";

        if (!isRadioCheckboxOrButton || isSelectedButton || $option.checked) {
          return acc.concat({
            value: $option.value,
            index: $option.getAttribute("data-index") || "option" + (arrayIndex + 1),
          });
        }
      }, []);
    },
  });

  function QuantityHandler(options) {
    this.selector = options.selector;

    this.dispatcher = new EventTarget();

    var $quantity = document.querySelector(options.selector);
    if (!$quantity) {
      return;
    }

    var that = this;
    if ($quantity instanceof HTMLSelectElement) {
      $quantity.addEventListener("change", function (e) {
        that._dispatchQuantity(that.getQuantity());
      });
    } else {
      $quantity.addEventListener("DOMSubtreeModified", function () {
        setTimeout(function () {
          that._dispatchQuantity(that.getQuantity());
        }, 10);
      });
    }
  }

  QuantityHandler.prototype = Object.assign({}, QuantityHandler.prototype, {
    on: function (event, cb) {
      this.dispatcher.addEventListener(event, cb);
    },

    getQuantity: function () {
      var $quantity = document.querySelector(this.selector);
      if (!$quantity) {
        return;
      }

      return $quantity instanceof HTMLSelectElement ? Number($quantity.value) : Number($quantity.innerText);
    },

    _dispatchQuantity: function (quantity) {
      this.dispatcher.dispatchEvent(
        new CustomEvent("updateQuantity", {
          detail: { quantity },
        })
      );
    },
  });

  /* utilities */
  function formatMoney(value) {
    return Intl.NumberFormat(Shopify.locale, {
      style: "currency",
      currency: Shopify.currency.active,
      minimumFractionDigits: 0,
    }).format(value);
  }

  function createElement(tag, classList, style, attributes) {
    var $el = document.createElement(tag);
    (classList || []).forEach(function (cls) {
      $el.classList.add(cls);
    });

    $el.style = Object.assign($el.style, style || {});
    Object.keys(attributes || {}).forEach(function (attribute) {
      $el.setAttribute(attribute, attributes[attribute]);
    });

    return $el;
  }

  function setElementDisabled($el, disabled) {
    if (!$el) return;
    if (disabled) {
      $el.setAttribute("disabled", true);
    } else {
      $el.removeAttribute("disabled");
    }
  }

  function show($el) {
    if (!$el) return;
    $el.classList.remove("hide");
  }

  function hide($el) {
    if (!$el) return;
    $el.classList.add("hide");
  }

  function updateText($el, text) {
    $el.innerText = text;
  }

  function strikeText($el, strike) {
    $el.style.textDecoration = strike ? "line-through" : "none";
  }

  function isHidden($el) {
    if (!$el) return false;
    return (
      $el.classList.contains("hide") || !($el.offsetWidth || $el.offsetHeight || $el.getClientRects().length)
    );
  }

  function createErrorMessage(message) {
    return "error: " + message;
  }
};